import _implicitStylesheets from "./progressBar.css";
import _implicitScopedStylesheets from "./progressBar.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"} aria-valuemin="0" aria-valuemax="100"${"a0:aria-valuenow"}${"a0:aria-busy"} role="progressbar"${2}><span class="slds-progress-bar__value${0}"${"s1"}${2}><span class="slds-assistive-text${0}"${2}>${"t3"}</span></span></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    className: api_normalize_class_name($cmp.computedClass),
    attrs: {
      "aria-valuenow": $cmp.percentValue,
      "aria-busy": $cmp.ariaBusy
    }
  }, null), api_static_part(1, {
    style: $cmp.computedStyle
  }, null), api_static_part(3, null, api_dynamic_text($cmp.assistiveText))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6fe1vtge1h4";
tmpl.legacyStylesheetToken = "lightning-progressBar_progressBar";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
